import React, { Component } from "react";
import Plans from "../../../components/Plans/Plans";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : PlansForm
Description : Componente que contienen la primera parte del formulario, definida previamente en la carpeta Components
Date Autor Modification
================================================================================
06/10/2023 Santiago Coca – Se llama al componente Plans
================================================================================ */
class PlansForm extends Component {
    render() {
        return (
            <Plans />
        )
    }
}

export default PlansForm;